import React from "react";
import "./SocialLinks.css";

function getSocialItems(userData) {
  return [
    {
      label: "Email",
      href: userData.email ? `mailto:${userData.email}` : "",
      icon: "bi bi-envelope-fill",
    },
    {
      label: "LinkedIn",
      href: userData.linkedIn || "",
      icon: "fab fa-linkedin-in",
    },
    {
      label: "GitHub",
      href: userData.github || "",
      icon: "fab fa-github",
    },
    {
      label: "X",
      href: userData.twitter || "",
      icon: "fab fa-x-twitter",
    },
    {
      label: "Orcid",
      href: userData.collegeId || "",
      icon: "fa-brands fa-orcid",
      iconStyle: { color: "rgba(var(--bs-link-color-rgb))" },
    },
    {
      label: "Scholar",
      href: userData.googleScholar || "",
      icon: "fa-brands fa-google-scholar",
    },
  ].filter((item) => item.href);
}

export default function SocialLinks({ userData, compact = false, className = "" }) {
  const items = getSocialItems(userData);
  const wrapperClassName = compact
    ? `social-links social-links-compact ${className}`.trim()
    : `social-links ${className}`.trim();

  return (
    <div className={wrapperClassName}>
      {items.map((item) => (
        <a
          key={item.label}
          className={compact ? "social-link social-link-compact" : "social-link"}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          title={item.label}
        >
          <i className={item.icon} style={item.iconStyle}></i>
          <span>{item.label}</span>
        </a>
      ))}
    </div>
  );
}
